import sortByEndDate from './utils/sortByEndDate';

const createAssignmentReducer = (state, action) => {
  if (action.status !== 'success') return state;

  const {
    payload: { assignment, spaceId },
  } = action;
  const updatedAssignments = [
    ...state.assignments,
    {
      ...assignment,
      classRoom: {
        objectId: spaceId,
      },
    },
  ].sort(sortByEndDate);

  return {
    ...state,
    assignments: updatedAssignments,
  };
};

export default createAssignmentReducer;
